import { __assign, __rest } from "tslib";
import * as React from 'react';
import { TranslationsProvider } from '../../i18next';
import { NamespacesConsumer } from 'react-i18next';
import { ReviewAppPage } from './review-app-page';
function ReviewAppPageExport(_a) {
    var locale = _a.locale, ReviewAppPageProps = __rest(_a, ["locale"]);
    return (React.createElement(TranslationsProvider, { locale: locale },
        React.createElement(NamespacesConsumer, null, function (t) { return React.createElement(ReviewAppPage, __assign({}, ReviewAppPageProps, { t: t })); })));
}
export { ReviewAppPageExport };
//# sourceMappingURL=review-app-page-export.js.map